
import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';

interface QuizProgressProps {
  currentQuestionIndex: number;
  totalQuestions: number;
  answeredCount: number;
  difficulty: string;
}

const QuizProgress: React.FC<QuizProgressProps> = ({
  currentQuestionIndex,
  totalQuestions,
  answeredCount,
  difficulty
}) => {
  const progress = (currentQuestionIndex / totalQuestions) * 100;
  
  const getDifficultyLabel = (difficulty: string) => {
    switch(difficulty.toLowerCase()) {
      case 'easy': return 'Easy (2 points)';
      case 'beginner': return 'Easy (2 points)';
      case 'intermediate': return 'Intermediate (3 points)';
      case 'advanced': return 'Advanced (4 points)';
      case 'expert': return 'Expert (5 points)';
      default: return `${difficulty} (3 points)`;
    }
  };

  const getDifficultyColor = (difficulty: string): string => {
    switch(difficulty.toLowerCase()) {
      case 'easy': 
      case 'beginner': 
        return 'bg-green-100 text-green-800 border-green-200';
      case 'intermediate': 
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'advanced': 
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'expert': 
        return 'bg-red-100 text-red-800 border-red-200';
      default: 
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-gray-600">
          Question {currentQuestionIndex + 1} of {totalQuestions}
        </div>
        <Badge 
          variant="outline" 
          className={`ml-2 ${getDifficultyColor(difficulty)}`}
        >
          {getDifficultyLabel(difficulty)}
        </Badge>
      </div>
      <div className="flex justify-between text-sm">
        <span>Question Progress</span>
        <span>Answered: {answeredCount}/{totalQuestions}</span>
      </div>
      <Progress value={progress} className="bg-gray-100 h-2" />
    </div>
  );
};

export default QuizProgress;
